import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Input,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl, SafeUrl } from "@angular/platform-browser";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

// Light Box
import { IEvent, Lightbox, LightboxEvent, LIGHTBOX_EVENT } from "ngx-lightbox";
import { Subscription } from "rxjs";
import { EventService } from "src/app/core/services/event.service";
import Swal from "sweetalert2";
import { CropperrDevelopmentsComponent } from "./cropperr/cropperr.component";
import { ImagesModel } from "./models/images.model";
import { VideosModel } from "./models/videos.model";
import { DevelopmentsService } from "../../../services/developments.services";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { TranslateService } from "@ngx-translate/core";
import { SimplebarAngularComponent } from "simplebar-angular";
import { LoadingService } from "src/app/core/services/loading.service";
import { PermissionsService } from "src/app/core/services/permissions.service";
import { PropertyDataService } from "src/app/core/services/property-data.service";
import {
  IMAGE_THUMB_SIZE,
  IMAGE_UPLOAD_MAX_BYTES,
  IMAGE_UPLOAD_MAX_COUNT,
  IMAGE_UPLOAD_MAX_MB,
  IMAGE_UPLOAD_MAX_ORIGINAL_BYTES,
  UploadProgress,
  compressImage,
  isValidImageType,
  prepareUploadFile,
  probeImageDimensions,
  renderFitThumbnail,
} from "../../../create-edit/multimedia/image-upload.util";
import { shouldFitWhole } from "../../../create-edit/multimedia/cropperr/crop-math";
@Component({
  selector: "app-multimedia-developments",
  templateUrl: "./multimedia.component.html",
  styleUrls: ["./multimedia.component.scss"],
})
export class MultimediaDevelopmentsComponent
  implements OnInit, AfterViewInit, OnDestroy {
  imageChangedEvent: any = "";
  croppedImage: any = "";
  images: { id: number; src: string; thumb: string; caption?: string }[] = [];
  videos: any[] = [];
  @ViewChild(CropperrDevelopmentsComponent, { static: true })
  cropperComponent!: CropperrDevelopmentsComponent;
  showCropper = false;
  subscriptionCropImage!: Subscription;
  subscriptionSubmitted!: Subscription;
  private lightboxsubscription!: Subscription;

  filterredImages: any;
  filterredVideos: any;
  galleryFilter = "images";

  @Input()
  propertyMultimediaData: any;
  list: any = { images: [], videos: [] };
  listDeleteImages: any = [];
  listDeleteVideos: any = [];
  countImages = 0;
  modalAddVideo!: NgbModalRef;
  multimediaFirst: number = 1;
  loginUser!: {
    id?: string;
    role?: { id?: string; name?: string };
    stores?: any[];
    associatedUsers?: any;
  };
  @Input()
  property: any;
  @ViewChild("simplebarMultimedia", { static: false })
  simplebarMultimedia!: SimplebarAngularComponent;
  /** Preparação das fotos novas em curso (uma de cada vez), com progresso na página. */
  uploadProgress: UploadProgress | null = null;

  constructor(
    private lightbox: Lightbox,
    private lightboxEvent: LightboxEvent,
    private eventService: EventService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private propertiesService: DevelopmentsService,
    public translate: TranslateService,
    private loadingService: LoadingService,
    public permissionsService: PermissionsService,
    private propertyDataService: PropertyDataService
  ) { }

  /** Partilha as imagens novas (ainda não guardadas) para a geração de descrição com IA */
  private syncListingImages() {
    const pendingFiles = (this.list?.images ?? [])
      .filter(
        (img: any) =>
          img?.isNew &&
          img?.status !== false &&
          (img?.originalFile instanceof File ||
            img?.originalFile instanceof Blob),
      )
      .slice(0, 6)
      .map((img: any, index: number) => {
        const source = img.originalFile;
        if (source instanceof File) return source;
        return new File([source], img?.name || `imagem-${index + 1}.jpg`, {
          type: source?.type || "image/jpeg",
        });
      });

    this.propertyDataService.updateListingImages(pendingFiles);
  }

  loadImges() {
    this.countImages = 0;
    this.filterredImages = this.list.images;
    this.images = [];
    for (const im of this.list.images) {
      const item: any = {
        id: im.id,
        src: im.img,
        caption: im.caption,
        thumb: im.img,
      };
      this.images.push(item);
      this.countImages++;
    }
  }

  loadVideos() {
    this.filterredVideos = this.list.videos;
    this.videos = [];
    for (const im of this.list.videos) {
      const item: any = {
        id: im.id,
        src: "/assets/images/placeholder.png",
        //caption: im.caption,
        //thumb: im.img
      };
      this.videos.push(item);
    }
  }

  ngOnInit(): void {
    const { id, role, stores, associatedUsers } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores, associatedUsers };

    this.list = this.propertyMultimediaData.data;
    if (this.list?.first) {
      this.multimediaFirst = this.list?.first;
    }
    this.listDeleteImages = this.propertyMultimediaData.dataDeleteImages;
    this.listDeleteVideos = this.propertyMultimediaData.dataDeleteVideos;
    this.loadImges();
    this.loadVideos();
    this.syncListingImages();
    if (!this.subscriptionCropImage) {
      this.subscriptionCropImage = this.eventService.subscribe(
        "crop-image-dev",
        (data: any) => {
          // O cropper só emite coordenadas: a imagem fica igual até o
          // servidor regenerar a publicada ao guardar. O preview (500 px)
          // serve só para o card.
          if (!data) return;
          const d: any = this.list.images?.find(
            (x: { id: any }) => x?.id === data?.id
          );
          if (!d) return;
          d.crop = data.crop ?? null;
          d.cropDirty = true;
          d.cropPreview = data.cropPreview ?? null;
          if (!d.originalThumb) d.originalThumb = d.thumb;
          if (data.cropPreview) {
            d.img = data.cropPreview;
            d.thumb = data.cropPreview;
          } else if (d.originalThumb) {
            d.img = d.originalThumb;
            d.thumb = d.originalThumb;
          }
          this.loadImges();
          this.eventService.broadcast("get-data-tab-multimedia-dev");
        }
      );
    }
  }

  ngAfterViewInit(): void {
    this.subscriptionSubmitted = this.eventService.subscribe(
      "get-data-tab-multimedia-dev",
      () => {
        // this.eventService.broadcast('data-tab-multimedia', { data: this.list, dataDeleteImages: this.listDeleteImages, dataDeleteVideos: this.listDeleteVideos });
        this.propertyMultimediaData.errors =
          this.propertyMultimediaData?.data?.images?.length > 0 ||
            this.propertyMultimediaData?.data?.images?.length > 0
            ? []
            : [{ warning: true }];
        this.list.first = this.multimediaFirst;
        this.propertyMultimediaData.data = this.list;
        this.propertyMultimediaData.dataDeleteImages = this.listDeleteImages;
        this.propertyMultimediaData.dataDeleteVideos = this.listDeleteVideos;

        const img = this.propertyMultimediaData?.data?.images?.find(
          (m: any) => m?.status === true
        );
        const vd = this.propertyMultimediaData?.data?.videos?.find(
          (m: any) => m?.status === true
        );
        this.propertyMultimediaData.errors =
          img || vd ? [] : [{ warning: true }];

        this.eventService.broadcast("ckeck-warning-add-dev");
      }
    );
  }

  /***
   * Active all category selected
   */
  activeCategory(category: string) {
    this.galleryFilter = category;
    if (this.galleryFilter === "videos") {
      this.filterredVideos = this.list.videos;
    } else if (this.galleryFilter === "images") {
      this.filterredImages = this.list.images.filter(
        (x: { category: string }) => x.category === this.galleryFilter
      );
    }
  }

  open(index: number): void {
    this.lightboxsubscription = this.lightboxEvent.lightboxEvent$.subscribe(
      (event: any) => this.onReceivedEvent(event)
    );
    // open lightbox
    if (this.galleryFilter === "videos") {
      this.lightbox.open(this.videos, index, {});
      let v: any = this.list.videos.find(
        (x: { id: any }) => x.id === index + 1
      );
      //let link = this.sanitizer.bypassSecurityTrustResourceUrl(v.link);
      const templateVideo: string = `<div class="ratio" style="--vz-aspect-ratio: 67%;">
        <iframe src="${v.link.changingThisBreaksApplicationSecurity}" title="YouTube video" allowfullscreen></iframe>
    </div>`;
      const t = setInterval(() => {
        const el: any = document.getElementById("image");
        if (el) {
          const c = el.parentElement;
          el.remove();
          c.innerHTML += templateVideo;
          clearInterval(t);
        }
      });
    } else {
      this.lightbox.open(this.images, index, {});
    }
  }

  close(): void {
    // close lightbox programmatically
    this.lightbox.close();
  }

  addImage() {
    const inputFile = document.getElementById("input-file-img");
    inputFile?.click();
  }

  /**
   * Fotos novas: uma de cada vez (descodificar uma foto de 24 MP custa
   * ~100 MB; três em paralelo rebentavam o Safari/iOS), com progresso na
   * página. O browser só reduz a 2000 px e faz a miniatura; o recorte 16:9
   * é do servidor (automático, ou manual pelo cropper).
   */
  async onFileChange(event: any) {
    if (!event.target?.files || event.target.files.length === 0) return;
    const filesArray = Array.from(event.target.files as FileList);
    event.target.value = "";

    const sortedFiles = filesArray.sort((a: File, b: File) =>
      a.name.localeCompare(b.name),
    );
    if (this.countImages + sortedFiles.length > IMAGE_UPLOAD_MAX_COUNT) {
      this.errorMsg(this.translate.instant("t-the-number-of-images-must-be-20"));
      return;
    }

    const tooLarge: string[] = [];
    let added = 0;
    this.setUploadProgress({ current: 0, total: sortedFiles.length, name: "" });

    for (let i = 0; i < sortedFiles.length; i++) {
      const file = sortedFiles[i];
      this.setUploadProgress({ current: i + 1, total: sortedFiles.length, name: file.name });
      try {
        if (!isValidImageType(file)) continue;
        if (file.size > IMAGE_UPLOAD_MAX_ORIGINAL_BYTES) {
          tooLarge.push(file.name);
          continue;
        }

        let dimensions: { width: number; height: number } | null = null;
        try {
          dimensions = await probeImageDimensions(file);
        } catch {
          dimensions = null;
        }
        // Reduzida a 2000 px só quando o original é maior; é o que vai
        // para o servidor e o que o cropper mostra.
        const uploadFile = await prepareUploadFile(file, dimensions);
        if (uploadFile.size > IMAGE_UPLOAD_MAX_BYTES) {
          tooLarge.push(file.name);
          continue;
        }
        const uploadDimensions =
          uploadFile === file
            ? dimensions
            : await probeImageDimensions(uploadFile).catch(() => dimensions);

        // Miniatura de 500 px para o card (derivada da reduzida, barata).
        let thumbFile: File | Blob = uploadFile;
        try {
          thumbFile = await compressImage(uploadFile, IMAGE_THUMB_SIZE);
        } catch (error: any) {
          console.error("Erro ao gerar a miniatura:", error?.message ?? error);
        }
        // Quando o recorte 16:9 perderia demasiado, o servidor publica a
        // imagem inteira com fundo desfocado: o card mostra já o mesmo.
        if (shouldFitWhole(uploadDimensions?.width, uploadDimensions?.height)) {
          thumbFile = await renderFitThumbnail(thumbFile);
        }
        const thumbUrl: any = this.getSafeImageUrl(URL.createObjectURL(thumbFile));
        const fullUrl: any = this.getSafeImageUrl(URL.createObjectURL(uploadFile));

        const id = this.list.images.length + 1;
        this.list.images.push({
          id,
          name: file.name,
          img: thumbUrl,
          caption: "",
          category: "images",
          thumb: thumbUrl,
          isNew: true,
          autoCrop: false,
          originalFile: uploadFile,
          status: true,
          isAvailable: true,
          hasMaster: true,
          masterWidth: uploadDimensions?.width ?? null,
          masterHeight: uploadDimensions?.height ?? null,
          crop: null,
          cropMode: null,
          cropDirty: false,
          cropPreview: null,
        });
        this.images.push({ id, src: fullUrl, caption: "", thumb: thumbUrl });
        this.filterredImages = this.list.images;
        this.countImages = this.list.images.length;
        added++;
        if (added === 1) {
          this.eventService.broadcast("get-data-tab-multimedia-dev");
        }
        this.syncListingImages();
      } catch (error: any) {
        console.error("Erro ao preparar a imagem:", error?.message ?? error);
      }
    }

    this.setUploadProgress(null);
    if (added > 0) this.loadImges();
    if (tooLarge.length > 0) {
      this.errorMsg(
        this.translate.instant("t-upload-files-larger-than-max-mb", {
          max: IMAGE_UPLOAD_MAX_MB,
        }),
      );
    }
  }

  private setUploadProgress(progress: UploadProgress | null) {
    this.uploadProgress = progress;
    // O formulário não deve ser gravado com a lista a meio.
    if (this.propertyMultimediaData) {
      this.propertyMultimediaData.preparingImages = !!progress;
    }
  }

  /** Recorte disponível: imagem nova com ficheiro, ou guardada (master ou publicada). */
  canCrop(data: any): boolean {
    if (!data) return false;
    if (data.isNew) return !!data.originalFile;
    return data.isAvailable !== false;
  }

  /** Imagem anterior ao recorte real: recorta-se dentro da publicada. */
  isLegacyCrop(data: any): boolean {
    return !!data && !data?.isNew && !data?.hasMaster;
  }


  formatType(type: any) {
    return type.split("/")[1];
  }

  cropImage(img: any) {
    this.showCropper = true;
    this.cropperComponent.open(img);
  }

  deleteImage(data: any) {
    this.list.images = this.list.images.filter(
      (x: { id: any }) => x.id !== data.id
    );
    for (let i = 0; i < this.list.images.length; i++) {
      this.list.images[i].id = i + 1;
    }

    this.loadImges();
    this.syncListingImages();
    if (!data.isNew) this.listDeleteImages.push(data);
    this.eventService.broadcast("get-data-tab-multimedia-dev");
  }

  deleteVideo(data: any) {
    this.list.videos = this.list.videos.filter(
      (x: { id: any }) => x.id !== data.id
    );
    this.loadVideos();
    if (!data.isNew) this.listDeleteVideos.push(data);
    this.eventService.broadcast("get-data-tab-multimedia-dev");
  }

  /**
   * Title sweet alert
   * @param Error Msg modal content
   */
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: this.translate.instant("t-something-wrong"),
      text: errorMsg,
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: "Close",
    });
  }

  onchangeCaption(event: Event, data: any) {
    // const newValue = (event.target as HTMLInputElement).value;
    // data.caption = newValue;
    data.caption = event;
    let dimage: any = this.images.find((x: { id: any }) => x.id === data.id);
    if (dimage) {
      dimage.caption = data.caption;
    }
  }

  onChangeActive(event: Event, data: any) {
    data.status = event;
    this.eventService.broadcast("get-data-tab-multimedia-dev");
  }

  /** Switch manual "gerada/alterada por IA" (Regulamento IA da UE, art. 50). */
  onChangeAiGenerated(value: boolean, data: any) {
    data.isAiGenerated = !!value;
    data.aiServiceCode = value ? data.aiServiceCode || "MANUAL" : null;
    this.eventService.broadcast("get-data-tab-multimedia-dev");
  }

  onchangeImageOrder(event: any, data1: any) {
    const idData1 = data1.id;
    const idData2 = +event.target.value;
    if (idData1 !== idData2) {
      let d1: any = this.list.images.find((x: { id: any }) => x.id === idData1);
      let d2: any = this.list.images.find(
        (x: { id: number }) => x.id === idData2
      );
      if (d1 && d2) {
        d1.id = idData2;
        d2.id = idData1;
      }
    }
    this.orderImages();
  }

  orderImages() {
    setTimeout(() => {
      this.list.images.sort((a: any, b: any) => {
        return a.id - b.id;
      });
      this.loadImges();
    });
  }

  /**
   * Open subscribe modal
   * @param subscribeDataModal subscribe modal data
   */
  subscribeModal(subscribeDataModal: any) {
    this.modalAddVideo = this.modalService.open(subscribeDataModal, {
      size: "lg",
      centered: true,
      backdropClass: "custom-body",
    });
  }

  private onReceivedEvent(event: IEvent): void {
    if (event.id === LIGHTBOX_EVENT.OPEN) {
    }
    if (event.id === LIGHTBOX_EVENT.CLOSE) {
      this.lightboxsubscription.unsubscribe();
    }
    if (event.id === LIGHTBOX_EVENT.CHANGE_PAGE) {
    }
  }

  saveVideo(value: any) {
    if (`${value}`.trim().length > 0) {
      const id = this.list.videos.length + 1;
      let link: any = this.getTrustedVideoURL(value);
      this.list.videos.push({
        id: id,
        link: link,
        category: "videos",
        isNew: true,
        videoId: 0,
      });
      this.loadVideos();
      this.modalAddVideo.dismiss();
    }
  }

  getTrustedVideoURL(videoURL: string): SafeResourceUrl {
    let srclink = videoURL;

    if (srclink.startsWith("https://www.youtube.com/watch?v=")) {
      let embedlink = srclink.replace("watch?v=", "embed/");
      embedlink = embedlink.split("&")[0];
      return this.sanitizer.bypassSecurityTrustResourceUrl(embedlink);
    } else if (srclink.startsWith("https://youtu.be")) {
      let embedlink = srclink.replace(
        "https://youtu.be",
        "https://www.youtube.com/embed/"
      );
      return this.sanitizer.bypassSecurityTrustResourceUrl(embedlink);
    } else if (
      srclink.startsWith("https://www.youtube.com/shorts/") ||
      srclink.startsWith("https://youtube.com/shorts/")
    ) {
      // Transformar Shorts em embed
      let embedlink = srclink.replace("/shorts/", "/embed/");
      return this.sanitizer.bypassSecurityTrustResourceUrl(embedlink);
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(srclink);
    }
  }

  onImageError(event: any, data: any) {
    event.target.src = "assets/images/no-image-available1_1.jpeg";
    if (data?.status) {
      data.isAvailable = false;
      const img = this.images.find((im) => im.id === data.id);
      if (img) {
        img.src = "assets/images/no-image-available1_1.jpeg";
        img.thumb = "assets/images/no-image-available1_1.jpeg";
      }
    }
  }

  ngOnDestroy(): void {
    this.eventService.broadcast("get-data-tab-multimedia-dev");
    this.subscriptionCropImage.unsubscribe();
    this.subscriptionSubmitted.unsubscribe();
  }

  blockScroll() {
    if (this.simplebarMultimedia) {
      // Acessa o elemento de rolagem do Simplebar e bloqueia o scroll
      const scrollElement =
        this.simplebarMultimedia.SimpleBar.getScrollElement();
      if (scrollElement) {
        // Bloqueia rolagem definindo pointer-events como 'none'
        scrollElement.style.pointerEvents = "none";
        scrollElement.scrollTop = scrollElement.scrollTop; // Manter a posição atual do scroll
      }
    }
  }

  unlockScroll() {
    if (this.simplebarMultimedia) {
      // Acessa o elemento de rolagem do Simplebar e desbloqueia o scroll
      const scrollElement =
        this.simplebarMultimedia.SimpleBar.getScrollElement();
      if (scrollElement) {
        // Restaura pointer-events para 'auto' para permitir rolagem
        scrollElement.style.pointerEvents = "auto";
      }
    }
  }

  getSafeImageUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
